import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import PropTypes from 'prop-types';

function FixedBottom({ children, fixedBottomSetting }) {
  const fixedBottomRowRef = useRef(null);
  const lastScrollYRef = useRef(0);
  // Starts hidden — window.scrollY doesn't exist during SSR, and the scroll listener below
  // corrects this immediately on mount anyway.
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScrollDirection = () => {
      const currentScrollY = window.scrollY;
      // Visible when scrolling up (or steady), hidden when scrolling down.
      setIsVisible(currentScrollY <= lastScrollYRef.current);
      lastScrollYRef.current = currentScrollY;
    };

    const handleScrollVisibility = () => {
      setIsVisible(window.scrollY > 100); // slide up when scroll past 100px, hide otherwise
    };

    const handleScroll = fixedBottomSetting === 'showHide' ? handleScrollDirection : handleScrollVisibility;

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [fixedBottomSetting]);

  return (
    <Row
      ref={fixedBottomRowRef}
      className={`fixed w-[100vw] bottom-0 bg-beige-100 py-[20px] px-0 z-[15] transition-transform duration-300
        ease-in-out ${isVisible ? 'translate-y-0' : 'translate-y-full'}`}
      style={{
        transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
      }}
    >
      <Col xsOffset={1} mdOffset={0} xs={6} sm={6} md={10} lg={12}>
        <Row>
          <Col xsOffset={0} xs={8} smOffset={0} sm={8} mdOffset={6} md={3} lgOffset={7} lg={4}>
            {children}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

FixedBottom.propTypes = {
  children: PropTypes.node.isRequired,
  fixedBottomSetting: PropTypes.oneOf(['show', 'showHide']).isRequired,
};

export default FixedBottom;
